import React from "react"
import { useTranslation } from "react-i18next"
import { formatPrice, getDisplayName, resolveProductUrl } from "../../utils/matching/matchingUtils"

export default function PPMatchingProductFacts({ product, isMaster, priceLang }) {
    const [t] = useTranslation()

    if (!product) {
        return null
    }

    const displayName = getDisplayName(product)
    const productLink = resolveProductUrl(product, isMaster ? priceLang : undefined)

    return (
        <div className="pp-matching-product-facts">
            {isMaster && <div className="pp-matching-product-facts__label">{t("matching.master_label")}</div>}

            {productLink ? (
                <a
                    href={productLink}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="pp-matching-product-facts__name"
                >
                    {displayName}
                </a>
            ) : (
                <div className="pp-matching-product-facts__name">{displayName}</div>
            )}

            <ul className="pp-matching-additional-details pp-matching-product-facts__meta">
                {product.producer && (
                    <li>
                        <strong>{t("matching.producer")}:</strong> {product.producer}
                    </li>
                )}
                {product.productNr && (
                    <li>
                        <strong>{t(isMaster ? "matching.product_nr" : "matching.catalog_product_nr")}:</strong>{" "}
                        {product.productNr}
                    </li>
                )}
            </ul>

            <div className="pp-matching-product-facts__price">{formatPrice(product.price)}</div>
        </div>
    )
}
